import React from "react";
import "./styles/EntradaBlog.css";
import { Link, useRouteMatch } from "react-router-dom";
import styled from "@emotion/styled";

const StyledBlogCard = styled.div`
  box-shadow: 1px 1px 10px rgba(0, 0, 0, 0.473);
  padding: 1em 2em;
  margin-top: 2rem;
  border-radius: 10px;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  min-height: 28em;
  & .entrada-blog-img {
    min-height: 10em;
    max-height: 10em;
    overflow: hidden;
    object-position: center;
  }
  & div:nth-child(2) {
  }
  & > div:nth-child(3) {
  }

  @media (min-width: 480px) {
    margin: 1em 4em;
    min-height: 31em;
  }
  @media (min-width: 720px) {
    margin: 1em 0em;
  }
`;

const EntradaBlog = ({ data }) => {
  let match = useRouteMatch();

  return (
    <Link to={`${match.url}/${data.postid}`}>
      <StyledBlogCard className={`c-entrada_blog`}>
        <div className="">
          <h4 className="display-4 uppercase">{data.posttitle}</h4>
          <div className="entrada-blog-img ">
            <img
              src={data.imagenes.principal}
              alt="Esta es la imagen"
              className="img-fit"
            />
          </div>
        </div>
        <div className="entrada-body">{data.postsubtitle.slice(0, 40)}...</div>
        <div className="entrada-footer">
          <span>Fecha:</span> {data.postdate.getDay()}/
          {data.postdate.getMonth()}
          <Link className="boton" to={`${match.url}/${data.postid}`}>
            Leer mas
          </Link>
        </div>
      </StyledBlogCard>
    </Link>
  );
};

export default EntradaBlog;
